import { render, staticRenderFns } from "./StudentContact.vue?vue&type=template&id=052e9c8a&"
import script from "./StudentContact.vue?vue&type=script&lang=ts&"
export * from "./StudentContact.vue?vue&type=script&lang=ts&"
import style0 from "./StudentContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports